import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, PaginatedResponse, Response } from '@tcc-mono/shared/data-access';
import { Animal, Koppel, KoppelAnimal, TransportGroup } from '@tcc-mono/vandijk/shared/data-access/models';

@Injectable({
  providedIn: 'root'
})
export class KoppelService extends BaseService<Koppel> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/koppels'
  }

  //:id/add_animals/transport_group

  public importTransportGroup(koppelId: number, transportGroupId: number) {
    const usedUrl = this.getUrl(`${this.path}/${koppelId}/add_animals/transport_group`);
    return this._http.post(usedUrl, {'transport_group_id': transportGroupId});
  }

  public animals(koppelId: number, page = 1): Observable<Response<KoppelAnimal[]>>  {
    const usedUrl = this.getUrl(`${this.path}/${koppelId}/animals`);
    return this._http.get<Response<KoppelAnimal[]>>(usedUrl + '?page='+ page);
  }

}
